export const TranslationsTA = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
        ms: 'Bahasa Melayu',
        ro: 'Română',
        cs: 'Čeština',
        hu: 'Magyar',
        ta: 'தமிழ்',
        te: 'తెలుగు',
        bn: 'বাংলা',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
        ms: 'MS',
        ro: 'RO',
        cs: 'CS',
        hu: 'HU',
        ta: 'TA',
        te: 'TE',
        bn: 'BN',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
        ms: 'MSA',
        ro: 'RON',
        cs: 'CES',
        hu: 'HUN',
        ta: 'TAM',
        te: 'TEL',
        bn: 'BEN',
    },
    // BASE
    phrases: {
        order_online: 'ஆன்லைனில் ஆர்டர் செய்யுங்கள்',
        cart: 'வண்டி',
        open_24: '24 மணிநேரம்',
        closed: 'மூடப்பட்டது',
        free: 'இலவசம்',
        something_went_wrong: 'ஏதோ தவறாகிவிட்டது',
        try_again: 'மீண்டும் முயற்சிக்கவும்',
    },
    constants: {
        calendar: {
            days: {
                monday: 'திங்கட்கிழமை',
                tuesday: 'செவ்வாய்',
                wednesday: 'புதன்',
                thursday: 'வியாழன்',
                friday: 'வெள்ளிக்கிழமை',
                saturday: 'சனிக்கிழமை',
                sunday: 'ஞாயிறு',
            },
        },
        services: {
            pickup: 'பிக்கப்',
            delivery: 'டெலிவரி',
            dine_in: 'உணவருந்தவும்',
            table_booking: 'அட்டவணை முன்பதிவு',
        },
        payment: {
            method: {
                cash: 'கைப்பேசி',
                card: 'கார்டு',
                stripe: 'Credit Card',
                paypal: 'PayPal',
                cardconnect: 'Credit Card',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Custom',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net'
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'கைப்பேசி',
                card: 'கார்டு',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online'
            },
            status: {
                success: 'வெற்றி',
                pending: 'நிலுவையில் உள்ளது',
                error: 'பிழை',
                refunded: 'திருப்பி கொடுக்கப்பட்டது',
                refunding: 'திரும்பப் பெறுதல்',
                partial_refunded: 'பகுதி திரும்பப் பெறப்பட்டது',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'அகற்று',
                drop_here: 'உங்கள் கோப்புகளை இங்கே விடவும் அல்லது ஒன்றைத் தேர்ந்தெடுக்க கிளிக் செய்யவும்',
                accepts: '{{fileTypes}} கோப்புகளை ஏற்கிறது',
                errors: {
                    max_files: 'அதிகபட்சம் {{number}} அனுமதிக்கப்படுகிறது',
                    max_size: 'அதிகபட்ச கோப்பு அளவு {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'கடை இதிகாலம் மூடப்பட்டது மற்றும் உணவருந்தவும் அட்டவணை இதிகாலம் செய்யப்படாது. நீங்கள் அடுத்த தேதி மற்றும் நேரத்தில் ஆர்டர் செய்யலாம்',
            },
            buttons: {
                order: {
                    book_order: 'முன்பதிவு அட்டவணை / ஆன்லைனில் ஆர்டர்',
                    order_online: 'ஆன்லைனில் ஆர்டர் செய்யுங்கள்',
                    book_table: 'ஒரு அட்டவணையை பதிவு செய்யவும்',
                    order: 'ஆர்டர்',
                    book: 'புத்தகம்',
                    cart: 'வண்டி',
                    restart: 'மறுதொடக்கம்',
                    closed: 'கடை மூடப்பட்டது',
                    not_accepting: 'ஆர்டர்களை ஏற்கவில்லை',
                },
            },
        },
        modals: {
            auth: {
                login: 'உள்நுழைக',
                register: 'பதிவு செய்யுங்கள்',
                register_commence: 'தொடரவும்',
                register_complete: 'கணக்கை உருவாக்கவும்',
                register_confirmation_sent: 'உறுதிப்படுத்தல் குறியீடு உங்கள் மின்னஞ்சல் முகவரிக்கு அனுப்பப்பட்டது. முன்னுரிமையாக அதை உள்ளிடவும்',
                register_confirmation_resent: 'உறுதிப்படுத்தல் குறியீடு மீண்டும் அனுப்பப்பட்டது, உங்கள் செய்திகள் அல்லது மீண்டும் தொடக்கப்படுத்தவும்',
                register_restart: 'மறுதொடக்கம்',
                register_resend_code: 'குறியீட்டை மீண்டும் அனுப்பவும்',
                register_confirmation_code_subject: 'மின்னஞ்சல் உறுதிப்படுத்தல் குறியீடு',
                register_confirmation_code_email: 'உங்கள் மின்னஞ்சல் உறுதிப்படுத்தல் குறியீடு {{confirmation_code}} (24 மணிநேரத்தில் காலாவதியாகும்)',
                login_placeholder: 'மின்னஞ்சல்',
                password_placeholder: 'கடவுச்சொல்',
                confirm_password_placeholder: 'கடவுச்சொல்லை உறுதிப்படுத்தவும்',
                confirmation_code_placeholder: 'மின்னஞ்சல் உறுதிப்படுத்தல் குறியீடு',
                accept_terms: 'விதிமுறைகள் & நிபந்தனைகளை ஏற்கவும்',
                accept_terms_view: 'காண்க',
                login_facebook: 'பேஸ்புக் மூலம் உள்நுழைக',
                login_google: 'Google மூலம் உள்நுழைக',
                benefits: 'உங்கள் ஆர்டர்கள் அனைத்தையும் சேமிக்க உள்நுழையவும் அல்லது கணக்கை உருவாக்கவும்',
                logged_in: 'வெற்றிகரமாக உள்நுழைந்துள்ளது',
                logged_out: 'வெளியேறியது',
                password_reset: {
                    init_button: 'கடவுச்சொல் மீட்டமைப்பு அஞ்சல் அனுப்பவும்',
                    init_success: 'கடவுச்சொல் மீட்டமைப்பு இணைப்பு உங்கள் மின்னஞ்சலுக்கு அனுப்பப்பட்டது',
                    complete_button: 'கடவுச்சொல்லை மீட்டமைக்கவும்',
                    complete_success: 'கடவுச்சொல் வெற்றிகரமாக மீட்டமைக்கப்பட்டது, உங்கள் புதிய கடவுச்சொல்லுடன் உள்நுழைக',
                    forgot_password_text: 'உங்கள் கடவுச்சொல் மறந்துவிட்டதா?',
                    forgot_password_link: 'கடவுச்சொல்லை மீட்டமைக்கவும்',
                    remember_password_text: 'உங்கள் கடவுச்சொல் நினைவிருக்கிறதா?',
                    remember_password_link: 'திரும்பி போ',
                    invalid_title: 'கடவுச்சொல் மீட்டமைப்பு தவறானது',
                    invalid_description: 'இந்த கடவுச்சொல் மீட்டமைப்பு இணைப்பு தவறானது, அதற்கு பதிலாக புதிய ஒன்றைக் கோரவும்',
                    invalid_link: 'உள்நுழைவுக்குச் செல்லவும்',
                    title: 'கடவுச்சொல் மீட்டமைப்பு',
                    description: 'உங்கள் கணக்கிற்கான புதிய கடவுச்சொல்லை உள்ளிடவும்',
                },
                error_generic: 'ஏதோ தவறாகிவிட்டது, மீண்டும் முயற்சிக்கவும் அல்லது எங்களை தொடர்பு கொள்ளவும்',
                error_accept_terms: 'விதிமுறைகள் மற்றும் நிபந்தனைகளை ஏற்கவும்',
                error_password_length: 'கடவுச்சொல்லுக்கான குறைந்தபட்சம் 6 எழுத்துகள்',
                error_social: 'ஏதோ தவறாகிவிட்டது, மீண்டும் முயற்சிக்கவும் அல்லது எங்களைத் தொடர்பு கொள்ளவும்',
                error_confirmation_code: 'தவறான உறுதிப்படுத்தல் குறியீடு',
                error_invalid_code: 'தவறான உறுதிப்படுத்தல் குறியீடு',
                error_exists: 'பயனர் ஏற்கனவே இருக்கிறார்',
                error_invalid_email_pass: 'தவறான மின்னஞ்சல் முகவரி அல்லது கடவுச்சொல்',
                error_password_no_match: 'கடவுச்சொற்கள் ஒன்றுக்கொன்று பொருந்தவில்லை',
                error_user_not_found: 'அந்த மின்னஞ்சல் முகவரியுடன் எந்தப் பயனரும் இல்லை',
                error_invalid_email: 'தவறான மின்னஞ்சல் முகவரி',
                error_invalid_reset_token: 'தவறான மீட்டமைப்பு இணைப்பு, மற்றொன்றைக் கோரவும்',
            },
            booking: {
                form: {
                    name: 'முழுப் பெயர்',
                    email: 'மின்னஞ்சல் முகவரி',
                    phone: 'தொலைபேசி எண்',
                    number_of_people: 'மக்கள் எண்ணிக்கை',
                    number_of_people_max: 'நபர்களின் எண்ணிக்கை ({{max_people}} அதிகபட்சம்)',
                    number_of_people_min: 'நபர்களின் எண்ணிக்கை ({{min_people}} நிமிடம்)',
                    number_of_people_max_min: 'நபர்களின் எண்ணிக்கை ({{min_people}} முதல் {{max_people}} வரை)',
                    notes: 'குறிப்புகள் / சிறப்பு கோரிக்கைகள்',
                    submit: 'முன்பதிவு கோரிக்கையை சமர்ப்பிக்கவும்',
                    email_optional: '(விருப்பம்)',
                    date: 'தேதி',
                    duration: 'கால அளவு',
                    seating: 'கிடைக்கும் நேரங்கள்',
                    number_of_guests: 'விருந்தினர் எண்ணிக்கை',
                    notes_placeholder: 'ஒவ்வாமை, சந்தர்ப்பம், இருக்கை விருப்பம்',
                    reserving: 'முன்பதிவு செய்யப்படுகிறது...',
                    reserve_table: 'மேசை முன்பதிவு',
                    please_choose_a_date_and_time: 'தயவுசெய்து ஒரு தேதியையும் நேரத்தையும் தேர்ந்தெடுக்கவும்.',
                    invalid_people: 'நபர்களின் எண்ணிக்கை {{min}} முதல் {{max}} வரை இருக்க வேண்டும்.',
                    party_size_max_fallback: 'அனுமதிக்கப்பட்ட அதிகபட்சம்',
                    loading_available_times: 'கிடைக்கும் நேரங்கள் ஏற்றப்படுகின்றன…',
                    select_a_date_to_see_available_times: 'கிடைக்கும் நேரங்களைக் காண ஒரு தேதியைத் தேர்ந்தெடுக்கவும்.',
                    no_times_available_for_this_date: 'இந்த தேதிக்கு நேரங்கள் இல்லை. தயவுசெய்து வேறு நாளைத் தேர்ந்தெடுக்கவும்.',
                    shift: 'ஷிஃப்ட்',
                    service_times: 'சேவை நேரங்கள்',
                    new_shift: 'புதிய ஷிஃப்ட்',
                    time: 'நேரம்',
                    times: 'நேரங்கள்',
                    unavailable: 'கிடைக்கவில்லை',
                    available: 'கிடைக்கிறது',
                    required_name: 'தயவுசெய்து உங்கள் பெயரை உள்ளிடவும்.',
                    required_phone: 'தயவுசெய்து உங்கள் தொலைபேசி எண்ணை உள்ளிடவும்.',
                    required_email: 'தயவுசெய்து உங்கள் மின்னஞ்சலை உள்ளிடவும்.',
                    invalid_email: 'தயவுசெய்து செல்லுபடியாகும் மின்னஞ்சலை உள்ளிடவும்.',
                    required_terms: 'முன்பதிவு செய்வதற்கு முன் விதிமுறைகளை ஏற்கவும்.',
                    reservation_is_unavailable: 'முன்பதிவு கிடைக்கவில்லை.',
                    please_contact_the_restaurant_directly: 'தயவுசெய்து உணவகத்தை நேரடியாகத் தொடர்பு கொள்ளவும்.',
                    almost_done: 'கிட்டத்தட்ட முடிந்தது',
                    your_details: 'உங்கள் விவரங்கள்',
                    tell_us_who_s_coming: 'உங்கள் முன்பதிவை உறுதிப்படுத்த யார் வருகிறார்கள் என்று சொல்லுங்கள்.',
                    book_your_table: 'உங்கள் மேசையை முன்பதிவு செய்யுங்கள்',
                    choose_a_time_that_works_for_you: 'உங்களுக்கு ஏற்ற நேரத்தைத் தேர்ந்தெடுக்கவும்.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'உங்கள் முன்பதிவு கோரிக்கையை அனுப்புங்கள், மீதியை உணவகம் பார்த்துக்கொள்ளும்.',
                    select_date: 'தேதியைத் தேர்ந்தெடுக்கவும்',
                    standard: 'இயல்பு',
                    minutes: 'நிமிடங்கள்',
                    next: 'அடுத்து →',
                    back: '← பின்செல்',
                    accept_terms: 'நான் விதிமுறைகளையும் நிபந்தனைகளையும் ஏற்கிறேன்.',
                    info_1: 'உங்கள் முன்பதிவு ஏற்கப்படும்போது அல்லது மறுக்கப்படும்போது மின்னஞ்சல் அறிவிப்பைப் பெறுவீர்கள்',
                },
                errors: {
                    not_found: "புகார் இல்லை. அது ஒருபோதும் நீக்கப்பட்டதாக இருக்கலாம்",
                    generic: 'ஏதோ தவறாகிவிட்டது, பக்கத்தைப் புதுப்பிக்கவும் அல்லது எங்களைத் தொடர்பு கொள்ளவும்',
                    something_went_wrong: 'ஏதோ தவறாகிவிட்டது',
                    accept_terms: 'விதிமுறைகள் மற்றும் நிபந்தனைகளை ஏற்கவும்',
                    required_phone: 'உங்கள் தொலைபேசி எண்ணை உள்ளிடவும்',
                    required_email: 'தயவுசெய்து உங்கள் மின்னஞ்சலை உள்ளிடவும்',
                    required_zip: 'உங்கள் பில்லிங் ஜிப் குறியீட்டை உள்ளிடவும்',
                    required_name: 'தயவுசெய்து உங்கள் பெயரை உள்ளிடவும்',
                    invalid_email: 'சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும்',
                    invalid_phone: 'சரியான தொலைபேசி எண்ணை உள்ளிடவும்',
                    invalid_people: 'தவறான நபர்களின் எண்ணிக்கை',
                    missing_custom_fields: 'தேவையான அனைத்து புலங்களையும் நிரப்பவும்.',
                    booking_capacity_threshold: 'இந்த நேரத்திற்கு நாங்கள் நிரம்பிவிட்டோம். தயவுசெய்து வேறு நேரத்தை முயலவும்.',
                    slot_unavailable: 'இந்த எண்ணிக்கைக்கு நாங்கள் நிரம்பிவிட்டோம். தயவுசெய்து வேறு நேரத்தை முயலவும்.',
                    booking_date_paused: 'இந்த தேதிக்கான முன்பதிவுகள் இடைநிறுத்தப்பட்டுள்ளன. தயவுசெய்து வேறு நாளைத் தேர்ந்தெடுக்கவும்.',
                    invalid_table_assignment: 'அந்த மேசைகளில் உங்கள் குழுவிற்கு இடமில்லை. தயவுசெய்து வேறு நேரத்தைத் தேர்ந்தெடுக்கவும்.',
                    exceeded_order_limit: 'மிக அதிக முன்பதிவு கோரிக்கைகள். தயவுசெய்து பின்னர் மீண்டும் முயலவும்.',
                    validation_failed_recaptcha_v3: 'வழக்கத்திற்கு மாறான போக்குவரத்து கண்டறியப்பட்டது. நீங்கள் VPN பயன்படுத்துகிறீர்களா? மேலே உள்ள சரிபார்ப்பை முடித்து மீண்டும் முயலவும்.',
                    validation_failed_recaptcha_v2: 'முன்பதிவைத் தொடங்க முடியவில்லை. தயவுசெய்து மீண்டும் முயலவும் அல்லது வேறு முறையைப் பயன்படுத்தவும். நீங்கள் VPN பயன்படுத்தினால், முதலில் அதை அணைக்கவும்.',
                    booking_already_exists: 'இந்த முன்பதிவு ஏற்கனவே அனுப்பப்பட்டது. உங்கள் மின்னஞ்சலைச் சரிபார்க்கவும் அல்லது முன்பதிவு இணைப்பைத் திறக்கவும்.',
                    invalid_party_size: 'தயவுசெய்து செல்லுபடியாகும் எண்ணிக்கையைத் தேர்ந்தெடுக்கவும்.',
                    invalid_request: 'செல்லாத கோரிக்கை. தயவுசெய்து பக்கத்தைப் புதுப்பித்து மீண்டும் முயலவும்.',
                    table_booking_unavailable: 'மேசை முன்பதிவு கிடைக்கவில்லை.',
                },
            },
            cart: {
                title: 'வண்டி',
                proceed_to_checkout: 'வெளியேறவும்',
                edit_dish: 'திருத்தவும்',
                remove_dish: 'அகற்று',
                no_items_1: 'வண்டியில் பொருட்கள் இல்லை',
                no_items_2: 'தொடர முதலில் சிலவற்றைச் சேர்க்கவும்',
                free_delivery_notice: '{{value, currency}}க்கு மேல் உள்ள ஆர்டர்களுக்கு இலவச டெலிவரி',
                errors: {
                    min_order_promo: 'இந்த விளம்பரத்தைப் பயன்படுத்துவதற்கு முன் குறைந்தபட்ச கார்ட் மதிப்பு {{value, currency}} தேவை',
                    min_order_delivery: 'டெலிவரிக்கான குறைந்தபட்ச கார்ட் மதிப்பு {{value, currency}}',
                },
                promo: {
                    heading: 'விளம்பர குறியீடு',
                    placeholder: 'உங்கள் விளம்பரக் குறியீட்டை உள்ளிடவும்',
                    add: 'குறியீட்டைச் சேர்க்கவும்',
                    title: 'விளம்பரம் {{name}} கார்ட்டில் சேர்க்கப்பட்டது',
                    fixed_discount: '{{value, currency}} ஆஃப்',
                    percent_discount: '{{value}}% தள்ளுபடி',
                    added_to_cart: 'கார்ட்டில் விளம்பரம் சேர்க்கப்பட்டது',
                    errors: {
                        not_found: 'விளம்பரம் கிடைக்கவில்லை',
                        disabled: 'விளம்பரம் முடக்கப்பட்டுள்ளது',
                        not_available: 'விளம்பரம் தற்போது கிடைக்கவில்லை',
                        not_eligible: 'விளம்பரக் குறியீட்டைப் பயன்படுத்தத் தகுதியில்லை',
                        not_available_time: 'இந்த நேரத்தில் விளம்பரம் பொருந்தாது',
                        logged_in_only: 'இந்த விளம்பரத்தைப் பயன்படுத்த உள்நுழைந்திருக்க வேண்டும்',
                        already_used: 'இந்த விளம்பரத்தை நீங்கள் ஏற்கனவே பயன்படுத்தியுள்ளீர்கள்',
                        invalid: 'இந்த விளம்பரம் இனி செல்லுபடியாகாது',
                        invalid_service: 'நீங்கள் தேர்ந்தெடுத்த சேவைக்கு இந்த விளம்பரம் செல்லாது',
                        later_only: 'முன்கூட்டிய ஆர்டர்களுக்கு மட்டுமே செல்லுபடியாகும்',
                        now_only: 'உடனடியாக செலுத்த வேண்டிய ஆர்டர்களுக்கு மட்டுமே செல்லுபடியாகும், முன்கூட்டிய ஆர்டர்களுக்கு அல்ல',
                        generic: 'அச்சச்சோ... ஏதோ தவறாகிவிட்டது மற்றும் பதிவு செய்யப்பட்டுள்ளது',
                        dishes_required_multi: 'சில பொருட்கள் உங்கள் கார்ட்டில் சேர்க்கப்படும் போது மட்டுமே இந்த விளம்பரம் பயன்படுத்தப்படும்',
                        dishes_required_single: "இந்த விளம்பரம் மட்டுமே '{{dish}}' க்கு பயன்படுத்தப்படும்",
                    },
                },
                tip: {
                    title: 'ஆர்டர் உதவிக்குறிப்பு',
                    placeholder: 'ஆர்டர் உதவிக்குறிப்பைச் சேர்க்கவும்',
                },
            },
            free_items_promo: {
                title: 'இலவச பொருட்கள்',
                usage_confirmation: {
                    question: 'நீங்கள் இலவச பொருட்களைப் பெறத் தகுதியுடையவர். அவற்றைப் பார்த்து சேர்க்க விரும்புகிறீர்களா?',
                    cancellation: "இல்லை, நான் இலவச பொருட்களை விரும்பவில்லை",
                    acceptance: 'ஆம்',
                },
                free_items_selection: {
                    multiple: {
                        description: '{{number}} இலவச உருப்படி(களை) தேர்ந்தெடு',
                    },
                    single: {
                        description: 'இலவசப் பொருளைத் தேர்ந்தெடுக்கவும்',
                    },
                    confirm_button: 'உறுதிப்படுத்தவும்',
                },
            },
            checkout: {
                title: 'வெளியேறு',
                subtitle: 'உங்கள் ஆர்டர் விவரங்களை உறுதிப்படுத்தவும்',
                details: {
                    service: 'சேவை',
                    due: 'காரணமாக',
                    due_now_asap: 'இப்போது / விரைவில்',
                    address: 'டெலிவரி முகவரி',
                    total: 'மொத்தம்',
                    table: 'அட்டவணை',
                    store_location: 'ஸ்டோர் முகவரி',
                },
                customer: {
                    title: 'வாடிக்கையாளர்',
                    subtitle: 'உங்கள் ஆர்டரையும் விவரங்களையும் சேமிக்க உள்நுழைக',
                    button: 'உள்நுழைக',
                    name: 'முழுப் பெயர்',
                    email: 'மின்னஞ்சல்',
                    phone: 'தொலைபேசி',
                    phone_important: 'தொலைபேசி (முக்கியம்)',
                    notes: 'ஆர்டர் குறிப்புகள்',
                    delivery_notes: 'டெலிவரி வழிமுறைகள் / ஆர்டர் குறிப்புகள்',
                    optional: 'விருப்பமானது',
                },
                payment: {
                    title: 'பணம் செலுத்தும் முறை',
                    qr_modal_help: 'உங்கள் {{app}} மொபைல் பயன்பாட்டைப் பயன்படுத்தி QR குறியீட்டை செயல்படுத்தி இந்த ஆர்டரைக் காட்டிலும் பணம் செலுத்தவும். பணம் உங்கள் மொபைல் பயன்பாட்டில் முடிந்தபின் நீங்கள் இந்த QR மொபைல் பயன்பாட்டை மூடலாம். நீங்கள் பணம் செலுத்தியிருக்காது என்றால் இந்த QR மொபைல் பயன்பாட்டை மூடக்கூடாது.',
                    switch_to_app_help: 'கீழே உள்ள பொத்தானை அழுத்தி, {{app}} மொபைல் பயன்பாட்டை திறக்கப்படும் பணம் செலுத்தப்படும். பணம் உங்கள் மொபைல் பயன்பாட்டில் முடிந்தபின் நீங்கள் இந்த மொபைல் பயன்பாட்டை மூடலாம். நீங்கள் பணம் செலுத்தியிருக்காது என்றால் இந்த மொபைல் பயன்பாட்டை மூடக்கூடாது.',
                    open_app: '{{app}} பயன்பாட்டைத் திறக்கவும்',
                    continue: 'தொடரவும்',
                    continue_to_payment: '{{method}} க்கு தொடரவும்',
                    back_to_cart: 'வண்டிக்குத் திரும்பு',
                },
                accept_terms: 'விதிமுறைகள் & நிபந்தனைகளை ஏற்கவும்',
                accept_terms_view: 'காண்க',
                processing_order: 'செயலாக்க ஆணை',
                warning: {
                    different_payment_currency: 'கடை விலைகள் {{store_currency}} இல் உள்ளன ஆனால் பணம் செலுத்தும் முறை {{payment_currency}} இல் உள்ளன',
                    closing_soon: 'விரைவில் மூடப்படும், ஆர்டர்கள் {{value}} நிமிடங்களுக்குள் செய்யப்பட வேண்டும்',
                    closed: 'மன்னிக்கவும், இந்த சேவை மூடப்பட்டது மற்றும் ஆர்டர்கள் ஏற்கப்படவில்லை',
                    paused: 'மன்னிக்கவும், இந்தச் சேவை இடைநிறுத்தப்பட்டுள்ளது, தற்போது வரை ஆர்டர்கள் ஏற்கப்படவில்லை',
                    expired: 'நீங்கள் தேர்ந்தெடுத்த நேரத்தில் உங்கள் ஆர்டரை இனி எங்களால் நிறைவேற்ற முடியாது. தயவுசெய்து பிந்தைய தேதி அல்லது நேரத்தைத் தேர்ந்தெடுக்கவும்',
                },
                errors: {
                    walletly_promo: 'Walletly விளம்பரத்தில் பிழை உள்ளது, தயவுசெய்து மற்றொரு விளம்பரத்தை முயற்சிக்கவும்!',
                    stripe_generic: 'கிரெடிட் கார்டு பிழை, மீண்டும் முயற்சிக்கவும் அல்லது வேறு முறை',
                    validation_failed: 'இந்த கட்டணத்தை தற்போது ஏற்க முடியாது. பிறகு முயற்சிக்கவும் அல்லது வேறு கட்டண முறையைத் தேர்வு செய்யவும்.',
                    validation_failed_recaptcha_v3: 'வழக்கத்திற்கு மாறான போக்குவரத்து கண்டறியப்பட்டது. நீங்கள் VPN ஐப் பயன்படுத்துகிறீர்களா? மேலே உள்ள சவாலை முடித்துவிட்டு மீண்டும் முயற்சிக்கவும்.',
                    validation_failed_recaptcha_v2: 'எங்களால் கட்டணத்தைத் தொடங்க முடியவில்லை. மீண்டும் முயற்சிக்கவும் அல்லது வேறு முறையைப் பயன்படுத்தவும். நீங்கள் VPN ஐப் பயன்படுத்துகிறீர்கள் என்றால், முதலில் அதை அணைக்க முயற்சிக்கவும்.',
                    stripe_loading_fail: 'கட்டணப் படிவத்தை ஏற்றுவதில் பிழை, மீண்டும் முயற்சிக்கவும்',
                    something_went_wrong: 'ஏதோ தவறாகிவிட்டது',
                    paypal_generic: 'PayPal இல் ஏதோ தவறாகிவிட்டது, மீண்டும் முயற்சிக்கவும் அல்லது வேறு கட்டண முறையைத் தேர்ந்தெடுக்கவும்',
                    payment_fail: 'பணம் செலுத்த முடியவில்லை, மீண்டும் முயற்சிக்கவும் அல்லது வேறு கட்டண முறையைத் தேர்ந்தெடுக்கவும்',
                    payment_cancelled: 'கட்டணம் ரத்துசெய்யப்பட்டது, மீண்டும் முயற்சிக்கவும் அல்லது வேறு கட்டண முறையைத் தேர்ந்தெடுக்கவும்',
                    payment_error: 'ஆன்லைன் கட்டணத்தைச் செயலாக்குவதில் பிழை, மீண்டும் முயற்சிக்கவும் அல்லது வேறு கட்டண முறையைத் தேர்ந்தெடுக்கவும்',
                    payment_declined: 'உங்கள் கட்டண முறை நிராகரிக்கப்பட்டது',
                    card_declined: "உங்கள் கார்டு நிராகரிக்கப்பட்டது மற்றும் பணம் செலுத்த முடியவில்லை",
                    promo_max_uses_exceeded: "இந்த ப்ரோமோ குறியீடு அதன் பயன்பாட்டு வரம்பை எட்டியுள்ளது, இனி கிடைக்காது.",
                    store_closed: 'கடை மூடப்பட்டுள்ளது, இனி ஆர்டர்களை ஏற்க முடியாது',
                    accept_terms: 'விதிமுறைகள் மற்றும் நிபந்தனைகளை ஏற்கவும்',
                    required_payment: 'கட்டண முறையைத் தேர்ந்தெடுக்கவும்',
                    required_phone: 'உங்கள் தொலைபேசி எண்ணை உள்ளிடவும்',
                    required_email: 'தயவுசெய்து உங்கள் மின்னஞ்சலை உள்ளிடவும்',
                    required_zip: 'உங்கள் பில்லிங் ஜிப் குறியீட்டை உள்ளிடவும்',
                    required_name: 'தயவுசெய்து உங்கள் பெயரை உள்ளிடவும்',
                    invalid_email: 'சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும்',
                    invalid_phone: 'சரியான தொலைபேசி எண்ணை உள்ளிடவும்',
                    invalid_cc_number: 'உங்கள் கிரெடிட் கார்டு எண் தவறானது',
                    invalid_order_amount: 'இந்தக் கட்டண முறைக்குத் தேவையான குறைந்தபட்சத் தொகை',
                    retry_cc_number: 'ஏதோ தவறாகிவிட்டது, உங்கள் கிரெடிட் கார்டு எண்ணை மீண்டும் உள்ளிட்டு மீண்டும் முயற்சிக்கவும்',
                    closed: 'கடை மூடப்பட்டு ஆர்டர்களை ஏற்கவில்லை',
                    promo_login_required: 'இந்த விளம்பரத்தைப் பயன்படுத்த உள்நுழைந்திருக்க வேண்டும்',
                    promo_used: 'இந்த விளம்பரத்தை நீங்கள் ஏற்கனவே பயன்படுத்தியுள்ளீர்கள்',
                    promo_by_payment_method_not_applicable: 'தேர்ந்தெடுத்த கட்டண முறைக்கு விளம்பரம் பொருந்தாது.',
                    missing_custom_checkout_fields: 'தேவையான அனைத்து புலங்களையும் நிரப்பவும்.',
                    delivery_unavailable: 'டெலிவரி சேவை இதிகாலம் கிடைக்காது. தயவுசெய்து பின்னர் நேரத்தை தேர்வு செய்யவும்',
                    required_delivery_provider: 'சேவை வழங்கலைத் தேர்ந்தெடுக்கவும்.',
                    required_delivery_quotation: 'டெலிவரி மதிப்பீடு காலாவதியானது.',
                    exceeded_order_limit: 'தற்போது நிறைய ஆர்டர்களைப் பெறுகிறோம். தயவுசெய்து பின்னர் நேரத்தை தேர்வு செய்யவும்.',
                    exceeded_order_limit_later: 'நீங்கள் தேர்ந்தெடுத்த நேரத்தில் உங்கள் ஆர்டரை இனி எங்களால் நிறைவேற்ற முடியாது. தயவுசெய்து பிந்தைய தேதி அல்லது நேரத்தைத் தேர்ந்தெடுக்கவும்',
                },
                button: {
                    continue: 'பணம் செலுத்துவதைத் தொடரவும்',
                    place_order: 'ஆர்டர் வைக்கவும்',
                    update_order: 'ஆர்டரைப் புதுப்பிக்கவும்',
                },
                delivery_estimation: {
                    title: 'விநியோக மதிப்பீடு',
                    details: {
                        provider: 'டெலிவரி வழங்குபவர்',
                        estimated_fee: 'மதிப்பிடப்பட்ட கட்டணம்',
                        estimated_total_fee: 'டெலிவரி கட்டணம் மொத்தம்',
                        estimated_discount_fee: 'டெலிவரி கட்டண தள்ளுபடி',
                        previous_estimated_fee: 'முந்தைய மதிப்பிடப்பட்ட கட்டணம்',
                        tips: 'குறிப்புகள்',
                        estimated_delivery_time: 'மதிப்பிடப்பட்ட டெலிவரி நேரம்',
                        uber_new_estimation: 'புதிய மதிப்பீட்டைக் கோருங்கள்',
                        uber_new_estimation_success: 'புதிய Uber டெலிவரி மதிப்பீடு பயன்படுத்தப்பட்டது.',
                        uber_estimation_expired: 'டெலிவரி மதிப்பீடு காலாவதியானது',
                        uber_price: 'நாங்கள் Uber விலையை வைத்திருக்கிறோம்',
                        uber_need_time: 'எனக்கு இன்னும் நேரம் தேவை',
                        lalamove_price: 'நாங்கள் லாலாமோவ் டெலிவரி கட்டணத்தை வைத்திருக்கிறோம்',
                        lalamove_new_estimation_success: 'புதிய லால்மூவ் டெலிவரி மதிப்பீடு பயன்படுத்தப்பட்டது.',
                        lalamove_estimation_expired: 'டெலிவரி மதிப்பீடு காலாவதியானது',
                        lalamove_need_time: 'எனக்கு இன்னும் நேரம் தேவை',
                        lalamove_new_estimation: 'புதிய மதிப்பீட்டைக் கோருங்கள்',
                    },
                    quotation_error: 'டெலிவரி மதிப்பீட்டைக் கணக்கிடுவதில் ஏதோ தவறு ஏற்பட்டது.',
                },
            },
            customer: {
                age_v: {
                    title: 'வயது சரிபார்ப்பு',
                    required_for_items: 'சில பொருட்களை ஆர்டர் செய்ய வேண்டும்',
                    min_age: 'குறைந்தபட்ச வயது: {{age}} ஆண்டுகள்',
                    est_time: 'மதிப்பிடப்பட்ட சரிபார்ப்பு நேரம்: {{time}} மணிநேரம்',
                    upload_description: 'சரிபார்ப்புக்கு உங்கள் ஐடியை பதிவேற்றவும். சரிபார்க்கப்பட்டபோது உங்களுக்கு மின்னஞ்சல் அறிவிப்பு அனுப்பப்படும். பதிவேற்றப்பட்டுள்ள 2 படங்கள் மற்றும் ஒவ்வொன்றும் 2 MB அளவுக்கு மிகப்பெரியது',
                    pending_description_1: 'உங்கள் ஆவணங்களை பதிவேற்றியதற்கு நன்றி. உங்கள் ஒப்புதலுக்காக மின்னஞ்சல் அறிவிப்பு அனுப்பப்படும்',
                    pending_description_2: 'சரிபார்ப்பு நிலையை புதுப்பிக்க பக்கத்தை புதுப்பிக்கவும். மதிப்பிடப்பட்ட சரிபார்ப்பு நேரம் {{time}} மணிநேரம்',
                    approved_description: 'உங்கள் கணக்கு சரிபார்க்கப்பட்டது மற்றும் தடைசெய்யப்பட்ட மெனுக்களிலிருந்து நீங்கள் ஆர்டர் செய்யலாம்',
                    rejected_description: 'உங்கள் ஐடி நிராகரிக்கப்பட்டது. நீங்கள் மீண்டும் முயற்சிக்க விரும்பினால், உங்கள் ஐடியை மீண்டும் பதிவேற்றவும்',
                    upload: 'பதிவேற்றவும்',
                    reupload: 'ஆவணங்களை மீண்டும் பதிவேற்றவும்',
                    go_back: 'திரும்பி செல்',
                    view_document: 'ஆவணத்தைப் பார்க்கவும் {{number}}',
                    status: {
                        unverified: 'சரிபார்க்கப்படாதது',
                        pending: 'ஒப்புதலுக்காக காத்திருக்கிறது',
                        approved: 'வெற்றிகரமாக சரிபார்க்கப்பட்டது',
                        rejected: 'நிராகரிக்கப்பட்டது',
                    },
                },
                headings: {
                    sessions: 'அமர்வுகள்',
                    orders: 'ஆர்டர்',
                    spend: 'செலவு செய்',
                    order_history: 'ஆர்டர் வரலாறு',
                    loyalty: 'விசுவாசம்',
                    loyalty_points: 'விசுவாச புள்ளிகள்',
                    added: 'விளம்பரம் சேர்க்கப்பட்டது.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'ரிடீம் செய்வதற்கு முன் ஏதேனும் ஒரு பொருளைத் தேர்ந்தெடுக்கவும்!',
                    not_found: 'விளம்பரம் கிடைக்கவில்லை!',
                    already_exists: 'விளம்பரம் ஏற்கனவே உள்ளது!',
                    try_again: 'இந்த ஒப்பந்தத்தைப் பயன்படுத்த முடியாது. மீண்டும் முயற்சிக்கவும்!',
                },
            },
            custom_payment: {
                title: '{{name}} கட்டணப் படிவம்',
                description: 'நீங்கள் எங்கள் ஆன்லைன் பணம் செலுத்தும் படிவத்திற்கு எதிர்பார்க்கிறீர்கள். பணம் செலுத்த கீழே உள்ள புலங்களை நிரப்பவும். பணம் செலுத்தப்படாதால், உங்கள் விவரங்கள் சேமிக்கப்படும் ஆனால் நீங்கள் பணம் செலுத்தப்படாது.',
                disabled: 'இந்த ஆன்லைன் பணம் செலுத்தும் பக்கம் சரியாக அமைக்கப்படவில்லை. சிக்கலை திருத்த கடை மற்றும் தயவுசெய்து கடை மற்றும் தயவுசெய்து கடை மற்றும் தயவுசெய்து கடை மற்றும் தயவுசெய்து கடை மற்றும் த',
                success: 'உங்கள் கட்டணம் வெற்றிகரமாகச் செயல்படுத்தப்பட்டு, உங்கள் விவரங்கள் சேமிக்கப்பட்டன. நன்றி',
                back: 'வீட்டிற்குத் திரும்பு',
                fields: {
                    name: 'முழுப் பெயர்',
                    email: 'மின்னஞ்சல் முகவரி',
                    reference: 'கட்டணம் Ref.',
                    amount: 'தொகை ($)',
                    name_on_card: 'அட்டையில் பெயர்',
                    submit: 'கட்டணத்தைச் சமர்ப்பிக்கவும்',
                },
                warning: {
                    currency: 'குறிப்பு: {{actual}} இல் கட்டணத் தொகை, {{default}} அல்ல',
                },
                errors: {
                    generic: 'ஏதோ தவறாகிவிட்டது, மீண்டும் முயற்சிக்கவும் அல்லது எங்களைத் தொடர்பு கொள்ளவும்',
                    stripe_generic: 'கிரெடிட் கார்டு பிழை, பக்கத்தைப் புதுப்பித்து மீண்டும் முயற்சிக்கவும்',
                    payment_fail: 'பணம் செலுத்த முடியவில்லை, மீண்டும் முயற்சிக்கவும் அல்லது வேறு கட்டண முறையைத் தேர்ந்தெடுக்கவும்',
                    payment_cancelled: 'கட்டணம் ரத்துசெய்யப்பட்டது, மீண்டும் முயற்சிக்கவும் அல்லது வேறு கட்டண முறையைத் தேர்ந்தெடுக்கவும்',
                    payment_error: 'ஆன்லைன் கட்டணத்தைச் செயலாக்குவதில் பிழை, மீண்டும் முயற்சிக்கவும் அல்லது வேறு கட்டண முறையைத் தேர்ந்தெடுக்கவும்',
                    payment_declined: 'உங்கள் கட்டண முறை நிராகரிக்கப்பட்டது',
                    card_declined: "உங்கள் கார்டு நிராகரிக்கப்பட்டது, கட்டணத்தை செயல்படுத்த முடியவில்லை.",
                    promo_max_uses_exceeded: "இந்த ப்ரோமோ குறியீடு அதன் பயன்பாட்டு வரம்பை எட்டியுள்ளது, இனி கிடைக்காது.",
                },
            },
            dish: {
                add: 'வண்டியில் சேர்',
                edit: 'உருப்படியைப் புதுப்பிக்கவும்',
                notes: 'சிறப்பு வழிமுறைகள்...',
                ingredients: {
                    title: 'தேவையான பொருட்கள்',
                    uncheck_remove: 'அகற்ற சரிபார்க்கவும்',
                },
                ingredients_title: 'தேவையான பொருட்கள்',
                combo: {
                    choose_dish: 'ஒரு பொருளைத் தேர்ந்தெடுக்கவும்',
                },
                option_sets: {
                    conditions: {
                        select_one: 'ஒன்றைத் தேர்ந்தெடு (தேவை)',
                        select_one_optional: 'ஒன்றைத் தேர்ந்தெடுக்கவும் (விரும்பினால்)',
                        select_between: '{{min}} - {{max}} இடையே தேர்ந்தெடு (தேவை)',
                        select_at_least: 'குறைந்தபட்சம் {{qty}} (தேவை) தேர்ந்தெடுக்கவும்',
                        select_up_to: '{{qty}} வரை தேர்ந்தெடுக்கவும் (விரும்பினால்)',
                        select_multiple_optional: 'பல தேர்ந்தெடுக்கவும் (விரும்பினால்)',
                        select_multiple: 'பல தேர்ந்தெடுக்கவும் (தேவை)',
                        free_amount: 'முதல் {{qty}} இலவசம் / {{selected}} தேர்ந்தெடுக்கப்பட்டது',
                    },
                    points: {
                        none_consumed: 'நீங்கள் அதிகபட்சமாக {{maxFree}} விருப்பங்களை இலவசமாகத் தேர்ந்தெடுக்கலாம்',
                        less_than_total_points: 'நீங்கள் கூடுதல் விருப்பங்களை இலவசமாக தேர்வு செய்யலாம்',
                        greather_than_total_points: 'கூடுதல் கட்டணத்திற்கான கூடுதல் விருப்பங்களை நீங்கள் தேர்வு செய்யலாம்',
                    },
                },
                error: 'சிவப்பு நிறத்தில் குறிக்கப்பட்ட ஏதேனும் விருப்பங்களை சரிசெய்யவும்',
                added_to_cart: 'கார்ட்டில் உருப்படி சேர்க்கப்பட்டது',
            },
            map: {
                zone_fee: 'டெலிவரி கட்டணம்',
                view_in_google: 'கூகுள் மேப்ஸில் பார்க்கவும்',
            },
            portal_go_back: {
                title: 'உணவகத் தேடலுக்குச் செல்லவா?',
                description: 'உங்கள் வண்டியில் உள்ள அனைத்து பொருட்களும் இழக்கப்படும்',
                cancel: 'ரத்து செய்',
                proceed: 'திரும்பி செல்',
            },
            order: {
                config: {
                    services: {
                        title: 'ஒரு சேவையைத் தேர்ந்தெடுக்கவும்',
                        table_booking: 'புத்தக அட்டவணை',
                    },
                    address_custom: {
                        input_placeholder: 'உங்கள் முகவரியை உள்ளிடவும்',
                    },
                    address: {
                        input_placeholder: 'உங்கள் டெலிவரி முகவரியைக் கண்டறியவும்',
                        extras_placeholder: 'யூனிட் எண், கட்டிடத்தின் பெயர், விநியோக வழிமுறைகள் போன்றவை...',
                        search_placeholder: 'உங்கள் முகவரியைத் தேடுங்கள்',
                        search_input_placeholder: 'தேட தட்டச்சு செய்யவும்',
                        no_address_found: 'முகவரிகள் இல்லை. 5 எழுத்துகளுக்கு மேல் தட்டச்சு செய்ய முயற்சிக்கவும்',
                        not_found: 'டெலிவரி முகவரி கிடைக்கவில்லை அல்லது செல்லுபடியாகும், மீண்டும் முயற்சிக்கவும்',
                        not_delivering: 'இந்த முகவரிக்கு நாங்கள் தற்போது டெலிவரி செய்யவில்லை',
                        not_in_range: 'உங்கள் முகவரி எங்கள் கடையின் இருப்பிட வரம்பில் இல்லை',
                        not_in_zone: 'உங்கள் முகவரி செயலில் உள்ள டெலிவரி மண்டலத்தில் இல்லை',
                        no_number: 'உங்கள் முகவரிக்கு தெரு எண் இருக்க வேண்டும்',
                        location_permission: 'உங்கள் தற்போதைய இருப்பிடத்தை அணுக இந்த இணையதளத்தை அனுமதிக்கவா?',
                        location_permission_warning: "உங்கள் தற்போதைய இருப்பிடத்தை அணுக இந்த இணையதளத்தை அனுமதிக்கவா? தயவுசெய்து உங்கள் சாதனத்தில் இருப்பிடம் சேவையை இயக்கவும் மற்றும் இணைய உலாவியில் அனுமதிக்கவும். இங்கே சில கருத்துகள்:",
                        pick_location: 'உங்கள் இருப்பிடத்தைத் தேர்ந்தெடுக்கவும்',
                        pick_location_help_text: 'வரைபடத்தில் இருப்பிடத்தைத் தேர்வுசெய்ய மார்க்கரை இழுக்கவும்.',
                        use_current_location: 'தற்போதைய இருப்பிடத்தைப் பயன்படுத்தவும்',
                        locate_on_map: 'வரைபடத்தில் கண்டறிக',
                    },
                    datetime: {
                        title: 'உங்கள் ஆர்டரை எப்போது விரும்புவீர்கள்',
                        due_now: 'இப்போது',
                        due_later: 'பின்னர்',
                        service_not_available: 'மன்னிக்கவும், நாங்கள் தற்போது {{service}}க்கான ஆர்டர்களை ஏற்கவில்லை',
                        currently_closed: '{{service}} தற்போது மூடப்பட்டது ஆனால் நீங்கள் பின்னர் ஆர்டர் செய்யலாம்',
                        due_unavailable: 'கிடைக்கவில்லை',
                        due_closed: 'மூடப்பட்டது',
                        select_date: 'தேதியைத் தேர்ந்தெடுக்கவும்',
                        select_time: 'நேரத்தைத் தேர்ந்தெடுக்கவும்',
                        select_order_date: 'உங்கள் ஆர்டர் தேதியைத் தேர்ந்தெடுக்கவும்',
                        select_order_time: 'உங்கள் ஆர்டர் நேரத்தைத் தேர்ந்தெடுக்கவும்',
                        select_order_date_time: 'உங்கள் ஆர்டர் தேதி/நேரத்தைத் தேர்ந்தெடுக்கவும்',
                        select_booking_date: 'உங்கள் முன்பதிவு தேதியைத் தேர்ந்தெடுக்கவும்',
                        select_booking_time: 'உங்கள் முன்பதிவு நேரத்தைத் தேர்ந்தெடுக்கவும்',
                        no_times_available: 'தேர்வு செய்ய நேரங்கள் இல்லை',
                        date_today: '(இன்று)',
                        date_closed: '(மூடப்பட்டது)',
                        date_bookings_paused: '(முன்பதிவு இடைநிறுத்தம்)',
                        time_slot_closed: 'மூடப்பட்டது',
                    },
                    number_of_people: {
                        placeholder: 'மக்கள் எண்ணிக்கை',
                    },
                    table: {
                        select: 'அட்டவணையைத் தேர்ந்தெடுக்கவும்',
                        select_popup_title: 'உங்கள் அட்டவணையைத் தேர்ந்தெடுக்கவும்',
                        password: 'அட்டவணை கடவுச்சொல்',
                        password_warning: 'தொடர உங்கள் அட்டவணை கடவுச்சொல்லை உள்ளிடவும்',
                    },
                    warning: {
                        closed: 'மன்னிக்கவும், நாங்கள் தற்போது மூடப்பட்டுள்ளோம் / எந்த ஆர்டர்களையும் ஏற்கவில்லை',
                        not_available: 'மன்னிக்கவும், நாங்கள் தற்போது எந்த ஆர்டரையும் ஏற்கவில்லை',
                    },
                    eta: {
                        delivery: `மதிப்பிடப்பட்ட டெலிவரி நேரம் தோராயமாக {{minutesToCustomer}} நிமிடங்கள்`,
                        pickup: `ஆர்டர் சுமார் {{minutesToCustomer}} நிமிடங்களில் தயாராகிவிடும்`,
                    },
                    start_button: 'ஆர்டரைத் தொடங்கவும்',
                },
                history: {
                    invalid: 'சில ஆர்டர் செய்யப்பட்ட பொருட்கள் மாற்றப்பட்டுள்ளன அல்லது இனி கிடைக்கவில்லை என்பதால் மீண்டும் ஆர்டர் செய்ய முடியாது.',
                },
                reorder: {
                    title: 'விரைவான மறு ஆர்டர்',
                    description: 'உங்கள் முந்தைய ஆர்டர்களிலிருந்து பொருட்களை எளிதாக ஆர்டர் செய்யுங்கள்',
                },
            },
            receipt: {
                errors: {
                    not_found: 'ஆர்டர் கிடைக்கவில்லை, பக்கத்தைப் புதுப்பித்து மீண்டும் முயற்சிக்கவும்',
                    booking_not_found: 'முன்பதிவு இல்லை. அது நீக்கப்பட்டிருக்கலாம்',
                    generic: 'ஏதோ தவறாகிவிட்டது, பக்கத்தைப் புதுப்பிக்கவும் அல்லது எங்களைத் தொடர்பு கொள்ளவும்',
                },
                connection: {
                    connected: 'நிகழ் நேர புதுப்பிப்புகள்',
                    connecting: 'நிகழ்நேர புதுப்பிப்புகள் இணைக்கப்படுகின்றன',
                    disconnected: 'நிகழ்நேர புதுப்பிப்புகள் துண்டிக்கப்பட்டன',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'எச்சரிக்கை',
                    title: 'வெளியேறு',
                    body: 'வெளியேறுவது உங்கள் கார்ட்டில் சேர்க்கப்பட்ட அனைத்து பொருட்களையும் அகற்றும்',
                    cancel: 'ரத்து செய்',
                    proceed: 'தொடரவும்',
                },
                order_restart: {
                    warning: 'எச்சரிக்கை',
                    title: 'ஆர்டர் விவரங்களை மாற்றவும்',
                    body: 'சில பொருட்கள் கிடைக்காமல் போகலாம் என்பதால் உங்கள் ஆர்டர் விவரங்களை மாற்றினால் உங்கள் கார்ட்டில் உள்ள பொருட்கள் அகற்றப்படும்',
                    cancel: 'ரத்து செய்',
                    proceed: 'தொடரவும்',
                },
                order_expired: {
                    subtitle: 'முக்கியமானது',
                    title: 'ஆர்டர் உடனடியாக காலாவதியாக மாற்றப்பட்டது',
                    description: 'உங்கள் ஆர்டர் க்கு தேர்ந்தெடுக்கப்பட்ட நேரம் இப்போது அருகில் இல்லை. எனவே உங்கள் ஆர்டர் உடனடியாக / ASAP க்கு மாற்றப்பட்டது',
                    button: 'சரி',
                },
                order_expiring: {
                    subtitle: 'முக்கியமானது',
                    title: 'ஆர்டர் காலக்கெடு விரைவில் முடிவடைகிறது',
                    description: 'உங்கள் ஆர்டர் {{time, timeFromTimestamp}}க்கு முன் வைக்கப்பட வேண்டும் இல்லையெனில் அது செல்லுபடியாகாது',
                    button: 'சரி',
                },
                location_permission: {
                    cancel: 'ரத்து செய்',
                    proceed: 'தொடரவும்',
                },
            },
            card_payment_authentication: {
                title: 'கட்டண அங்கீகாரம்',
                note: 'உங்கள் வங்கியின் அங்கீகாரச் செயல்முறையை நிறைவு செய்யும் வரை இந்தச் சாளரத்தைத் திறந்து வைக்கவும்.',
            },
            maps: {
                cancel: 'ரத்து செய்',
                use_location: 'இருப்பிடத்தைப் பயன்படுத்தவும்',
            },
            app_refresh: {
                refresh: 'புதுப்பிக்கவும்',
                title: 'ரெஃப்ரெஷ் ஸ்டோர்',
                description: 'எங்கள் கடை புதுப்பிக்கப்பட்டுள்ளது. சமீபத்திய பதிப்பைப் பெற உங்கள் உலாவியை புதுப்பிக்கவும். புதுப்பித்த பிறகு, பணம் செலுத்தும் செயல்முறையை தொடர உங்கள் வண்டியை மீண்டும் திறக்க வேண்டி இருக்கலாம்.',
            },
        },
        sections: {
            nav_top: {
                guest: 'விருந்தினர்',
                login: 'உள்நுழைக',
                login_signup: 'உள்நுழையவும் / பதிவு செய்யவும்',
                logout: 'வெளியேறு',
            },
            menus: {
                info: {
                    no_menus: 'தற்போது மெனுக்கள் எதுவும் இல்லை',
                    restrictions: 'மெனு கட்டுப்பாடுகள்',
                    not_available: 'மெனு கிடைக்கவில்லை',
                    unavailable: {
                        times: "மெனு கிடைக்கவில்லை, உங்கள் ஆர்டர் தேவைகள் கீழே உள்ளவற்றுடன் பொருந்தவில்லை.",
                        services: "மெனு கிடைக்கவில்லை, உங்கள் ஆர்டர் தேவைகள் கீழே உள்ளவற்றுடன் பொருந்தவில்லை.",
                        hours: 'மெனு கிடைக்கவில்லை, இந்த மெனுக்கள் கிடைக்கும் மணிநேரத்திற்குள் உங்கள் ஆர்டர் நேரம் இல்லை',
                        pre_order: "மெனு கிடைக்கவில்லை, உங்கள் ஆர்டர் முன்பதிவு தேவைகளுடன் பொருந்தவில்லை.",
                        age: 'மெனு கிடைக்கவில்லை, இந்த மெனுவிலிருந்து ஆர்டர் செய்ய வயது சரிபார்க்கப்பட்ட கணக்கில் உள்நுழைந்திருக்க வேண்டும்',
                    },
                    services: {
                        title: 'ஆர்டர் தேவைகள்',
                        pickup: 'பிக்கப்ஸ்',
                        delivery: 'விநியோகங்கள்',
                        dine_in: 'டைன்-இன்ஸ்',
                    },
                    times: {
                        now: 'முன்கூட்டிய ஆர்டர்கள் இல்லை',
                        later: 'முன்கூட்டிய ஆர்டர்கள் மட்டுமே',
                    },
                    hours: {
                        title: 'கிடைக்கும் நேரம்',
                    },
                    preorder: {
                        title: 'முன்-ஆர்டர் தேவைகள்',
                        days_in_advance: '{{days}} நாட்களுக்கு முன்னதாக ஆர்டர் செய்ய வேண்டும்',
                        cutoff_time: 'கடைசி நாள் கட்-ஆஃப் நேரம் {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'வயது வரம்பு',
                        approved: 'உங்கள் கணக்கு சரிபார்க்கப்பட்டது, இந்த மெனுவிலிருந்து நீங்கள் ஆர்டர் செய்யலாம்',
                        rejected: 'ஆர்டர் செய்ய வயது சரிபார்ப்பு தேவை. ஒரு கணக்கை உருவாக்கி உங்கள் ஐடியைப் பதிவேற்றவும்',
                    },
                },
                search: {
                    title: 'மெனு உருப்படிகளை ஆராயுங்கள்',
                    no_result: 'எதுவும் திரும்ப வரவில்லை. வேறொரு தேடல் சொல்லை முயற்சிக்கவா?',
                    placeholder: 'நீங்கள் என்ன தேடுகிறீர்கள்?',
                },
            },
            category: {
                restrictions: 'வகை கட்டுப்பாடுகள்',
                not_available: 'வகை கிடைக்கவில்லை',
                unavailable: {
                    services: "வகை கிடைக்கவில்லை, உங்கள் ஆர்டர் தேவைகள் கீழே உள்ளவற்றுடன் பொருந்தவில்லை.",
                    hours: "வகை கிடைக்கவில்லை, உங்கள் ஆர்டர் நேரம் இந்த வகைக்கான கிடைக்கும் நேரத்திற்குள் இல்லை.",
                },
            },
            info: {
                location: {
                    title: 'இடம்',
                    view_map: 'வரைபடத்தைப் பார்க்கவும்',
                    phone: 'தொலைபேசி',
                },
                hours: {
                    title: 'திறக்கும் நேரம்',
                    title_special: 'சிறப்பு திறக்கும் நேரம்',
                },
                services: {
                    title: 'சேவைகள்',
                    notes: 'குறிப்புகள்',
                    delivery: {
                        ranges: 'விநியோக வரம்புகள்',
                        zones: 'விநியோக மண்டலங்கள்',
                        view_zones: 'வரைபடத்தில் மண்டலங்களைக் காண்க',
                        fee: 'டெலிவரி கட்டணம்',
                        fee_short: 'கட்டணம்',
                        fee_varies: 'மாறுபடும், வண்டியில் காட்டப்பட்டுள்ளது',
                        min_order: 'குறைந்தபட்ச ஆர்டர்',
                        min_order_short: 'குறை. ஆர்ட.',
                        no_min_order: 'குறைந்தபட்ச ஆர்டர் இல்லை',
                        free_amount: 'இலவச டெலிவரி தொகை',
                    },
                },
            },
            contact: {
                title: 'எங்களை தொடர்பு கொள்ளவும்',
                name: 'பெயர்',
                email: 'மின்னஞ்சல்',
                phone: 'தொலைபேசி எண்',
                message: 'உங்கள் செய்தியை உள்ளிடவும்...',
                send: 'செய்தி அனுப்பு',
                success: 'உங்கள் செய்தி வெற்றிகரமாக அனுப்பப்பட்டது',
                error: 'ஏதோ தவறாகிவிட்டது, மீண்டும் முயற்சிக்கவும் அல்லது சிறிது நேரம் கழித்து முயற்சிக்கவும்',
            },
            footer: {
                powered_by: 'மூலம் இயக்கப்படுகிறது',
                terms_and_conditions: 'விதிமுறைகள் & நிபந்தனைகள்',
                privacy: 'தனியுரிமைக் கொள்கை',
                cookie: 'குக்கீ கொள்கை',
            },
        },
        pages: {
            payment_completed: {
                title: 'உங்கள் பணம் செலுத்தப்பட்டது. உங்கள் ஆர்டருக்கு நன்றி!',
                subtitle: 'ஆர்டர் தகவல் உங்கள் மின்னஞ்சல் முகவரிக்கு அனுப்பப்பட்டுள்ளது.',
                back_to_menu: 'மெனுவுக்குத் திரும்பு',
                close_tab: 'இந்த தாவலை மூடு',
            },
            payment_failed: {
                title: 'துரதிருஷ்டவசமாக உங்கள் கட்டணத்தைச் செயலாக்கும்போது பிழை ஏற்பட்டது.',
                subtitle: '',
                back_to_menu: 'மெனுவுக்குத் திரும்பு',
                close_tab: 'இந்த தாவலை மூடு',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'முன்பதிவு ரசீது',
            details: {
                datetime: 'முன்பதிவு',
                number_of_people: 'மக்கள் எண்ணிக்கை',
                placed: 'வைக்கப்பட்டது',
                updated: 'கடைசியாக புதுப்பிக்கப்பட்டது',
                notes: 'குறிப்புகள்',
                name: 'பெயர்',
                email: 'மின்னஞ்சல்',
                phone: 'தொலைபேசி',
                store_address: 'ஸ்டோர் முகவரி',
            },
            status_update: {
                title: 'முன்பதிவு {{number}} புதுப்பிக்கப்பட்டது',
                body: 'உங்கள் முன்பதிவு நிலை {{status}} க்கு புதுப்பிக்கப்பட்டது',
            },
            email_common: {
                name: 'பெயர்: {{name}}',
                phone: 'தொலைபேசி: {{number}}',
                number_of_people: 'நபர்களின் எண்ணிக்கை: {{number}}',
                date: 'தேதி: {{date}}',
                time: 'நேரம்: {{time}}',
                location: 'ஸ்டோர் இடம்: {{name}}',
                notes: 'குறிப்புகள்: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'புதிய அட்டவணை முன்பதிவு {{number}} by {{name}}',
                powered_by: '{{name}} ஆல் இயக்கப்படுகிறது',
                overview: 'புதிய அட்டவணை முன்பதிவு கோரிக்கை',
                title: '{{name}}க்கான புதிய முன்பதிவு',
                subtitle: 'முன்பதிவு எண் {{number}}',
                description_confirmed: 'புகார் உறுதிப்படுத்தப்பட்டது. நிர்வாகி டாஷ்போர்டு மூலம் முன்பதிவை உறுதிப்படுத்தவும் அல்லது ரத்து செய்யவும்',
                description_unconfirmed: 'நிர்வாகி டாஷ்போர்டு மூலம் முன்பதிவை உறுதிப்படுத்தவும் அல்லது ரத்து செய்யவும்',
                url_pre_text: 'இல் பார்க்கவும் புதுப்பிக்கவும்',
            },
            email_new_booking_customer: {
                subject: 'அட்டவணை முன்பதிவு கோரிக்கை',
                powered_by: '{{name}} ஆல் இயக்கப்படுகிறது',
                overview: 'புதிய அட்டவணை முன்பதிவு கோரிக்கை',
                title: 'உங்கள் முன்பதிவுக்கு நன்றி',
                subtitle: 'முன்பதிவு எண் {{number}}',
                description: '<b>உங்கள் முன்பதிவு உறுதிப்படுத்தப்பட்டது அல்லது ரத்துசெய்யப்பட்டது என்பதால் நீங்கள் மற்றொரு மின்னஞ்சலை பெறுவீர்கள்.</b><br>உங்கள் முன்பதிவை மாற்ற கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி ட',
                url_pre_text: 'உங்கள் நிகழ்நேர முன்பதிவு ரசீதை நீங்கள் பார்க்கலாம்',
            },
            email_update_booking_customer: {
                subject_confirmed: 'அட்டவணை முன்பதிவு உறுதிப்படுத்தப்பட்டது',
                subject_unconfirmed: 'அட்டவணை முன்பதிவு ரத்துசெய்யப்பட்டது',
                powered_by: '{{name}} ஆல் இயக்கப்படுகிறது',
                overview: 'அட்டவணை முன்பதிவு கோரிக்கை',
                title_confirmed: 'முன்பதிவு உறுதி செய்யப்பட்டது',
                title_unconfirmed: 'முன்பதிவு ரத்து செய்யப்பட்டது',
                subtitle: 'முன்பதிவு எண் {{number}}',
                description_confirmed: 'நாங்கள் நீங்களை பார்க்க எதிர்பார்க்கிறோம். உங்கள் முன்பதிவை மாற்ற கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்',
                description_unconfirmed: 'உங்கள் முன்பதிவை கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூலம் கோரிக்கையை நிர்வாகி டாஷ்போர்டு மூ',
                url_pre_text: 'உங்கள் நிகழ்நேர முன்பதிவு ரசீதை நீங்கள் பார்க்கலாம்',
            },
            email_status_update_customer: {
                subject: 'முன்பதிவு #{{number}} – {{subjectLabel}}',
                body: '{{store}}-இல் உங்கள் முன்பதிவு #{{number}} இப்போது {{status}}.',
            },
            errors: {},
            status_warning: 'முன்பதிவுகள் பக்கத்தில் உங்கள் நிர்வாக டாஷ்போர்டில் இந்த முன்பதிவின் நிலையைப் புதுப்பிக்கவும்',
        },
    },
    email_delayed_order: {
        subject: 'ஆர்டர் #{{number}} – {{subjectLabel}}',
        header: 'புதுப்பிக்கப்பட்ட தயாராகும் நேரம்',
        title: 'புதுப்பிக்கப்பட்ட தயாராகும் நேரம்',
        order_number: 'ஆர்டர் எண்: {{number}}',
        description: 'உங்கள் ஆர்டர் இப்போது {{time}}-க்குத் தயாராகும்.',
        order_time_updated_to: 'உங்கள் ஆர்டர் நேரம் புதுப்பிக்கப்பட்டது.',
        powered_by: '{{name}} ஆல் இயக்கப்படுகிறது',
        button_text: 'ஆர்டரைக் கண்காணிக்கவும்',
        subject_label: 'புதுப்பிக்கப்பட்ட தயாராகும் நேரம்',
        subject_label_delivery: 'புதுப்பிக்கப்பட்ட டெலிவரி நேரம்',
        body_ready: 'உங்கள் ஆர்டர் இப்போது {{time}}-க்குத் தயாராகும்.',
        body_delivery: 'உங்கள் ஆர்டர் இப்போது {{time}}-க்கு டெலிவரி செய்யப்படும்.',
    },
    order: {
        receipt: {
            est_ready_time: 'Est. தயார் நேரம்',
            est_driver_pickup_time: 'Est. டிரைவர் பிக் அப் நேரம்',
            est_delivery_time: 'Est. டெலிவரி நேரம்',
            tab_details: 'விவரங்கள்',
            tab_dishes: 'பொருட்கள்',
            future_order: 'எதிர்கால ஒழுங்கு',
            reprint: 'மறுபதிப்பு',
            details: {
                order_no: 'ஆணை எண்.',
                status: 'நிலை',
                placed: 'வைக்கப்பட்டது',
                due: 'காரணமாக',
                due_asap: 'இப்போது / விரைவில்',
                last_updated: 'கடைசியாக புதுப்பிக்கப்பட்டது',
                total: 'மொத்தம்',
                type: 'வகை',
                origin: 'தோற்றம்',
                table: 'அட்டவணை',
                number_of_people: 'மக்கள் எண்ணிக்கை',
                payment_method: 'பணம் செலுத்தும் முறை',
                payment_status: 'கட்டண நிலை',
                payment_currency: 'பணம் செலுத்தும் நாணயம்',
                notes: 'குறிப்புகள்',
                name: 'பெயர்',
                email: 'மின்னஞ்சல்',
                phone: 'தொலைபேசி',
                distance: 'தூரம்',
                driving_time: 'ஓட்டும் நேரம்',
                delivery_zone: 'மண்டலம்',
                delivery_address: 'டெலிவரி முகவரி',
                delivery_provider: 'டெலிவரி வழங்குபவர்',
                delivery_tracking: 'டெலிவரி கண்காணிப்பு',
                delivery_return_tracking: 'ட்ராக் ரிட்டர்ன்',
                delivery_tracking_link: 'ஆர்டரைக் கண்காணிக்கவும்',
                tookan_status: 'எடுக்கப்பட்ட நிலை',
                tookan_status_failed_book: 'புத்தக விநியோகம் தோல்வியடைந்தது',
                tookan_status_failed_update: 'முன்பதிவை புதுப்பிக்க முடியவில்லை',
                tookan_status_success: 'டெலிவரிக்காக முன்பதிவு செய்யப்பட்டது',
                store_address: 'ஸ்டோர் முகவரி',
                destination: 'இலக்கு',
                estimated_arrival_time: 'வருகை நேரத்தை மதிப்பிடவும்',
                delivery_status: 'நிலை',
                delivery_track_your_order: 'உங்கள் ஆர்டரைக் கண்காணிக்கவும்',
                delivery_text: 'டெலிவரி',
                arrival_date: 'வருகை தேதி',
            },
            dishes: {
                headings: {
                    quantity: 'Qty',
                    item: 'பொருள்',
                    price: 'விலை',
                },
                notes: 'குறிப்புகள்',
                remove_ingredients: 'மூலப்பொருட்களை அகற்றவும்',
            },
            status_update: {
                title: 'ஆர்டர் {{number}} புதுப்பிக்கப்பட்டது',
                body: 'உங்கள் ஆர்டர் நிலை {{status}} க்கு புதுப்பிக்கப்பட்டது',
            },
            wait_time_update: {
                title: 'ஆர்டர் {{number}} புதுப்பிக்கப்பட்டது',
                body: 'உங்கள் ஆர்டர் செலுத்த வேண்டிய நேரம் புதுப்பிக்கப்பட்டது',
            },
            delivery_update: {
                title: 'ஆர்டர் {{number}} புதுப்பிக்கப்பட்டது',
                body: 'உங்கள் ஆர்டர் டெலிவரிக்காக முன்பதிவு செய்யப்பட்டுள்ளது. நிகழ்நேர கண்காணிப்பு இணைப்பைப் பார்க்கவும்',
            },
            payment_status_update: {
                title: 'ஆர்டர் {{number}} புதுப்பிக்கப்பட்டது',
                body: 'உங்கள் ஆர்டர் கட்டண நிலை புதுப்பிக்கப்பட்டது.',
            },
            email_new_order_restaurant: {
                subject: 'புதிய ஆர்டர் ({{number}}) - {{name}}',
                powered_by: '{{name}} ஆல் இயக்கப்படுகிறது',
                overview: 'புதிய ஆர்டர் அறிவிப்பு',
                title: 'புதிய ஆர்டர் {{name}} இல் வைக்கப்பட்டது',
                subtitle: 'ஆர்டர் எண் {{number}}',
                description: 'உங்கள் நிர்வாக டாஷ்போர்டு மூலம் விவரங்களையும் புதுப்பிப்புகளையும் பார்க்கலாம்',
                button_text: 'ஆர்டரைக் கண்காணிக்கவும்',
                track_delivery_button_text: 'ட்ராக் டெலிவரி',
            },
            email_new_order_customer: {
                subject: 'ஆர்டர் ரசீது ({{number}})',
                powered_by: '{{name}} ஆல் இயக்கப்படுகிறது',
                overview: 'புதிய ஆர்டர் அறிவிப்பு',
                title: 'புதிய ஆர்டர் {{name}} இல் வைக்கப்பட்டது',
                subtitle: 'ஆர்டர் எண் {{number}}',
                description: 'உங்கள் நிகழ்நேர ஆன்லைன் ரசீது மூலம் விவரங்களையும் புதுப்பிப்புகளையும் பார்க்கலாம்',
                button_text: 'ஆர்டரைக் கண்காணிக்கவும்',
                track_delivery_button_text: 'ட்ராக் டெலிவரி',
            },
            email_order_completed_by_customer: {
                subject: 'ஆர்டர் ({{number}}) வாடிக்கையாளரால் முடிக்கப்பட்டது',
                powered_by: '{{name}} ஆல் இயக்கப்படுகிறது',
                overview: 'ஆர்டர் முடிந்த அறிவிப்பு',
                title: '{{name}} இல் ஆர்டர் முடிந்தது',
                subtitle: 'ஆர்டர் எண் {{number}}',
                description: 'உங்கள் டாஷ்போர்டு மூலம் அல்லது ரசீதைப் பயன்படுத்தி உங்கள் ஆர்டரின் விவரங்களைப் பார்க்கலாம் மற்றும் புதுப்பிக்கலாம்',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) inc. விலையில்',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'டெலிவரி கட்டணம்',
            delivery_fee_offset: 'டெலிவரி கட்டண தள்ளுபடி',
            delivery_fee_total: 'டெலிவரி கட்டணம் மொத்தம்',
            promo: 'தள்ளுபடி: {{name}} ({{value, currency}} + {{percent}}% தள்ளுபடி)',
            promo_percent: 'தள்ளுபடி: {{name}} ({{percent}}%)',
            promo_fixed: 'தள்ளுபடி: {{name}}',
            promo_none: 'தள்ளுபடி: {{name}}',
            cart: 'வண்டி',
            tip: 'ஆர்டர் உதவிக்குறிப்பு',
            total: 'மொத்தம்',
        },
        status: {
            unconfirmed: 'உறுதிப்படுத்தப்படாதது',
            awaiting_payment: 'பணம் செலுத்த காத்திருக்கிறது',
            confirmed: 'உறுதி செய்யப்பட்டது',
            ready: 'தயார்',
            on_route: 'பாதையில்',
            complete: 'நிறைவு',
            cancelled: 'ரத்து செய்யப்பட்டது',
            seated: 'அமர்த்தப்பட்டது',
        },
        searching: {
            lalamove_search_placeholder: 'லாலாமோவ் டெலிவரி ஐடி மூலம் ஆர்டரைத் தேடுங்கள்',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'கிடைக்கவில்லை',
                },
            },
            dish: {
                no_stock: 'கையிருப்பில் இல்லை',
                not_available: 'கிடைக்கவில்லை',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'மின்னஞ்சல் உறுதிப்படுத்தல் குறியீடு',
            register_confirmation_code_email: 'உங்கள் மின்னஞ்சல் உறுதிப்படுத்தல் குறியீடு {{confirmation_code}} (24 மணிநேரத்தில் காலாவதியாகும்)',
            register_confirmation_code_email_onbehalf: 'உங்கள் மின்னஞ்சல் உறுதிப்படுத்தல் குறியீடு {{confirmation_code}} (24 மணிநேரத்தில் காலாவதியாகும்). இது மின்னஞ்சல் முகவரி, {{email}} க்கானது.',
        },
    },
};
//# sourceMappingURL=ta.js.map